import NavigationArrows, { NavigationArrowsProps } from './NavigationArrows'

export default NavigationArrows

export { NavigationArrows }
export type { NavigationArrowsProps }
